if (!customElements.get("cart-form-modal")) {
  class cartFormModal extends HTMLElement {
    constructor() {
      super();

      this.closeCross = this.querySelector(".cart-form-modal-close-icon");
      this.closeButton = this.querySelector("[close-button]");
      this.isOpen = sessionStorage.getItem("cart-modal-form-open");
      this.mediaQuery = parseInt(this.dataset.mediaQuery);
      this.backdrop = this.querySelector(".cart-form-modal-backdrop");

      this.init();
    }

    init() {
      const clickHandlers = [
        { element: this.backdrop, handler: () => this.closeModal() },
        { element: this.closeCross, handler: () => this.closeModal() },
        {
          element: this.closeButton,
          handler: (e) => {
            e.preventDefault();
            this.closeModal();
          },
        },
      ];

      clickHandlers.forEach(({ element, handler }) => {
        if (element) {
          element.style.cursor = "pointer";
          element.addEventListener("click", handler);
        }
      });
      this.closeModal();
    }

    openModal() {
      this.style.display = "block";
      sessionStorage.setItem("cart-modal-form-open", "true");
      document.body.classList.add("ov-hidden");
    }

    closeModal() {
      document.body.classList.remove("ov-hidden");
      sessionStorage.setItem("cart-modal-form-open", "false");
      this.style.display = "none";

      if (window.matchMedia("(max-width: " + this.mediaQuery + "px)").matches) {
        this.classList.add("slide-down");
      } else {
        this.style.display = "none";
      }
    }
  }

  customElements.define("cart-form-modal", cartFormModal);
}

const getCart = async () => {
  return fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      return cart;
    })
    .catch((error) => console.error("Error al obtener el carrito:", error));
};

document.addEventListener("DOMContentLoaded", async function () {
  // CONSTANTES
  const localStorageName = "decision_tree";
  const raw = localStorage.getItem(localStorageName);

  const defaultData = { estancias: [] };

  let data;
  if (raw) {
    try {
      data = JSON.parse(raw);
    } catch (e) {
      console.warn(
        "JSON inválido en localStorage, usando valores por defecto.",
        e
      );
      data = defaultData;
    }
  } else {
    data = defaultData;
  }

  const situacionGeograficaStorageName = "situacion_geografica";
  const orientacionSolarStorageName = "orientacion_solar";
  const espacioAcondicionarStorageName = "espacio_acondicionar";
  const estanciasStorageName = "estancias";
  const estanciaMetrosStorageName = "estancia_metros";
  const unidadExteriorStorageName = "unidad_exterior";
  const unidadExteriorStorageName2 = "unidad_exterior_2";
  const installationStorageName = "installation";
  const distanciaBalconPatioStorageName = "distancia_balcon_patio";
  const distanciaBalconPatioStorageName2 = "distancia_balcon_patio_2";
  const distanciaAzoteaStorageName = "distancia_azotea";
  const distanciaAproximadaStorageNameStorageName = "distancia_aproximada";
  const anoViviendaStorageName = "en-que-ano-fue-construida-la-vivienda";
  const productIdStorageName = "product_id";

  const inputsRadio = [
    orientacionSolarStorageName,
    espacioAcondicionarStorageName,
    anoViviendaStorageName,
    estanciasStorageName,
    unidadExteriorStorageName,
    unidadExteriorStorageName2,
    distanciaAzoteaStorageName,
    distanciaAproximadaStorageNameStorageName,
  ];
  const estanciasNumberIds = ["estancias-Una", "estancias-Dos"];

  // ELEMENTS
  const acceptButton = document.querySelector(".cart-form-accept-button");
  const submitButton = document.querySelector(".cart-form-sub-button");
  const initialContent = document.querySelector(".cart-form-initial-content");
  const formContent = document.querySelector(".cart-form-final-content");
  const form = document.querySelector("#cart-form");
  const cartFormContent = document.querySelector(
    ".cart-form-content-container"
  );
  const ffInputBlockSubmit = formContent.querySelectorAll(
    "ff-input-block-submit"
  );

  // --- FORM ELEMENTS ----------------------
  const situacionGeograficaInput = document.getElementById(
    situacionGeograficaStorageName
  );
  const numberOfRoomsArray = document.querySelectorAll(".estancias");
  const onlyOneRoomElement = document.getElementById(estanciasNumberIds[0]);
  const onlyTwoRoomElement = document.getElementById(estanciasNumberIds[1]);
  // Contenedor dinámico de filas estancia + m². El metaobject puede traer
  // varios steps "rooms" (uno por nº de estancias en el recomendador). Aquí
  // sólo necesitamos uno; ocultamos los duplicados.
  const allRoomsContainers = document.querySelectorAll("[data-rooms-container]");
  const roomsContainer = allRoomsContainers[0] || null;
  const roomsStep = roomsContainer ? roomsContainer.closest("ff-input-block-submit") : null;
  for (let i = 1; i < allRoomsContainers.length; i++) {
    const duplicateStep = allRoomsContainers[i].closest("ff-input-block-submit");
    if (duplicateStep) duplicateStep.style.display = "none";
  }
  // ff-input-block-submit del step "¿prefieres una sola unidad exterior?"
  const preferenciaUnidadHandle = "prefieres-una-sola-unidad-exterior-para-toda-la-vivienda-o-te-da-igual-tener-una-por-estancia";
  const preferenciaUnidadStep = document.getElementById(`${preferenciaUnidadHandle}-parent`);
  // ff-input-block-submit del step "¿cuál es la distancia al balcón/patio?"
  const distanciaBalconPatioStep = document.getElementById(`${distanciaBalconPatioStorageName}-parent`);
  // Contenedor dinámico para filas estancia + distancia (creado on-demand)
  let distanciaBalconPatioContainer = null;
  // Steps que sólo aplican cuando se elige Azotea/Fachada en unidad_exterior
  const distanciaAzoteaStep = document.getElementById(`${distanciaAzoteaStorageName}-parent`);
  const alturaTechoStep = document.getElementById(`${distanciaAproximadaStorageNameStorageName}-parent`);
  // Unidad exterior
  const unidadExteriorParent = document.getElementById(
    `${unidadExteriorStorageName}-parent`
  );
  const unidadExteriorParent2 = document.getElementById(
    `${unidadExteriorStorageName2}-parent`
  );
  const unidadExteriorParentInputs = unidadExteriorParent
    ? unidadExteriorParent.querySelectorAll('input[type="radio"]')
    : [];
  const unidadExteriorParentInputs2 = unidadExteriorParent2
    ? unidadExteriorParent2.querySelectorAll('input[type="radio"]')
    : [];

  const unidadExteriorParentInputsPrimeros = [
    unidadExteriorParentInputs[0],
    unidadExteriorParentInputs[1],
  ].filter(Boolean);
  const unidadExteriorParentInputsUltimos = [
    unidadExteriorParentInputs[2],
    unidadExteriorParentInputs[3],
  ].filter(Boolean);

  const unidadExteriorParentInputsPrimeros2 = [
    unidadExteriorParentInputs2[0],
    unidadExteriorParentInputs2[1],
  ].filter(Boolean);
  const unidadExteriorParentInputsUltimos2 = [
    unidadExteriorParentInputs2[2],
    unidadExteriorParentInputs2[3],
  ].filter(Boolean);

  // Distancia azotea
  const distanciaAzoteaParent = document.getElementById(
    `${distanciaAzoteaStorageName}-parent`
  );
  const distanciaAzoteaChilds = distanciaAzoteaParent
    ? distanciaAzoteaParent.querySelectorAll('input[type="radio"]')
    : [];
  // Distancia balcon patio
  const distanciaBalconPatioParent = document.getElementById(
    `${distanciaBalconPatioStorageName}-parent`
  );
  const distanciaBalconPatioParent2 = document.getElementById(
    `${distanciaBalconPatioStorageName2}-parent`
  );
  const distanciaBalconPatioChilds = distanciaBalconPatioParent
    ? distanciaBalconPatioParent.querySelectorAll('input[type="radio"]')
    : [];
  const distanciaBalconPatioChilds2 = distanciaBalconPatioParent2
    ? distanciaBalconPatioParent2.querySelectorAll('input[type="radio"]')
    : [];

  // All inputs radio
  const allInputRadioElements = document.querySelectorAll(
    'input[type="radio"]'
  );
  // --- END FORM INPUTS -----------------------------

  let cart;
  let totalPotenciaRequerida;
  let product_id;

  const productsFromShopifyCollection = fillShopifyProductsFromCollection();

  // --- DYNAMIC ROOM ROWS ----------------------------
  function getRoomsConfig() {
    if (!roomsContainer) return null;
    const raw = roomsContainer.dataset.rooms;
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      // Aceptamos tanto { estancia_1: "habitacion,salon", ... } como ["habitacion","salon"]
      if (Array.isArray(parsed)) {
        return { keys: parsed.map((_, i) => `estancia_${i + 1}`), options: parsed.flatMap((v) => String(v).split(",")) };
      }
      const entries = Object.entries(parsed);
      const optionsSet = new Set();
      entries.forEach(([, v]) => String(v).split(",").forEach((o) => optionsSet.add(o.trim())));
      return {
        keys: entries.map(([k]) => k),
        options: [...optionsSet].filter(Boolean),
      };
    } catch (e) {
      console.warn("cart-form-modal: rooms JSON inválido", e);
      return null;
    }
  }

  function isLastEstanciasOption() {
    if (!numberOfRoomsArray || numberOfRoomsArray.length === 0) return false;
    const last = numberOfRoomsArray[numberOfRoomsArray.length - 1];
    return !!(last && last.checked);
  }

  function isSecondEstanciasOption() {
    if (!numberOfRoomsArray || numberOfRoomsArray.length < 2) return false;
    return !!numberOfRoomsArray[1].checked;
  }

  function toggleRoomsStep(visible) {
    if (!roomsStep) return;
    roomsStep.style.display = visible ? "" : "none";
  }

  function togglePreferenciaUnidadStep(visible) {
    if (!preferenciaUnidadStep) return;
    preferenciaUnidadStep.style.display = visible ? "" : "none";
  }

  function isBalconOrPatioSelected() {
    const radios = document.querySelectorAll(`input[name="${unidadExteriorStorageName}"]`);
    if (radios.length < 2) return false;
    return !!(radios[0].checked || radios[1].checked);
  }

  function isAzoteaOrFachadaSelected() {
    const radios = document.querySelectorAll(`input[name="${unidadExteriorStorageName}"]`);
    if (radios.length < 3) return false;
    return Array.from(radios).slice(2).some((r) => r.checked);
  }

  function toggleAzoteaAlturaSteps(visible) {
    if (distanciaAzoteaStep) distanciaAzoteaStep.style.display = visible ? "" : "none";
    if (alturaTechoStep) alturaTechoStep.style.display = visible ? "" : "none";
  }

  function ensureDistanciaContainer() {
    if (!distanciaBalconPatioStep) return null;
    if (distanciaBalconPatioContainer && distanciaBalconPatioStep.contains(distanciaBalconPatioContainer)) {
      return distanciaBalconPatioContainer;
    }
    // Quitamos los radios del metaobject viejo, preservando el label
    const label = distanciaBalconPatioStep.querySelector(".cart-form-label");
    distanciaBalconPatioStep.innerHTML = "";
    if (label) distanciaBalconPatioStep.appendChild(label);
    const container = document.createElement("div");
    container.className = "cart-form-distance-container";
    container.dataset.distanceContainer = "";
    distanciaBalconPatioStep.appendChild(container);
    distanciaBalconPatioContainer = container;
    return container;
  }

  function renderDistanceRows(previousValues) {
    const container = ensureDistanciaContainer();
    if (!container) return;
    container.innerHTML = "";

    const rooms = readRoomRows();
    if (rooms.length === 0) return;

    rooms.forEach((room, i) => {
      const row = document.createElement("div");
      row.className = "cart-form-room cart-form-distance-row";
      row.dataset.index = String(i);

      const labelEstancia = document.createElement("label");
      const spanEstancia = document.createElement("span");
      spanEstancia.className = "font-size-16 neutral-500 font-w-700";
      spanEstancia.textContent = `Estancia ${i + 1}:`;
      labelEstancia.appendChild(spanEstancia);

      const estanciaInput = document.createElement("input");
      estanciaInput.type = "text";
      estanciaInput.readOnly = true;
      estanciaInput.value = room.estancia || "";
      estanciaInput.className = "cart-form-input cart-form-m2 cart-form-estancia-name";
      estanciaInput.dataset.estancia = room.estancia || "";
      labelEstancia.appendChild(estanciaInput);
      row.appendChild(labelEstancia);

      const labelDistancia = document.createElement("label");
      const spanDistancia = document.createElement("span");
      spanDistancia.className = "font-size-16 neutral-500 font-w-700";
      spanDistancia.textContent = "Distancia";
      labelDistancia.appendChild(spanDistancia);

      const distanciaInput = document.createElement("input");
      distanciaInput.type = "number";
      distanciaInput.step = "0.1";
      distanciaInput.placeholder = "Introduce la distancia";
      distanciaInput.className = "cart-form-input cart-form-m2 cart-form-distance";
      const prev = Array.isArray(previousValues)
        ? previousValues.find((d) => d.estancia === room.estancia)
        : null;
      if (prev && prev.distancia !== "" && prev.distancia != null) {
        distanciaInput.value = prev.distancia;
      }
      labelDistancia.appendChild(distanciaInput);
      row.appendChild(labelDistancia);

      container.appendChild(row);
    });
  }

  function readDistanceRows() {
    if (!distanciaBalconPatioContainer) return [];
    return Array.from(
      distanciaBalconPatioContainer.querySelectorAll(".cart-form-distance-row")
    ).map((row) => ({
      estancia: row.querySelector(".cart-form-estancia-name").value,
      distancia: row.querySelector(".cart-form-distance").value,
    }));
  }

  function toggleDistanciaBalconPatioStep(visible) {
    if (!distanciaBalconPatioStep) return;
    distanciaBalconPatioStep.style.display = visible ? "" : "none";
  }

  function syncDistanciaBalconPatioStep(previousValues) {
    if (isBalconOrPatioSelected()) {
      toggleDistanciaBalconPatioStep(true);
      renderDistanceRows(previousValues);
    } else {
      toggleDistanciaBalconPatioStep(false);
      if (distanciaBalconPatioContainer) distanciaBalconPatioContainer.innerHTML = "";
    }
    toggleAzoteaAlturaSteps(isAzoteaOrFachadaSelected());
  }

  function getSelectedEstanciasCount() {
    const checked = document.querySelector('input[name="estancias"]:checked');
    if (!checked) return 1;
    const label = checked.closest("label");
    const text = (label ? label.textContent : checked.value || "").trim().toLowerCase();
    const map = { una: 1, dos: 2, tres: 3, cuatro: 4, cinco: 5, "cinco o más": 5 };
    if (map[text] != null) return map[text];
    const n = parseInt(text, 10);
    return isNaN(n) ? 1 : n;
  }

  function renderRoomRows(n, previousValues) {
    if (!roomsContainer) return;
    const config = getRoomsConfig();
    if (!config) return;

    const handle = roomsContainer.dataset.handle || "cuanto-mide-cada-estancia";
    const total = Math.max(1, n);

    roomsContainer.innerHTML = "";
    for (let i = 0; i < total; i++) {
      const row = document.createElement("div");
      row.className = "cart-form-room";
      row.dataset.index = String(i);

      const labelSelect = document.createElement("label");
      const selectSpan = document.createElement("span");
      selectSpan.className = "font-size-16 neutral-500 font-w-700";
      selectSpan.textContent = `Estancia ${i + 1}`;
      labelSelect.appendChild(selectSpan);

      const select = document.createElement("select");
      select.name = `${handle}-${i}`;
      select.className = "cart-form-input cart-form-select";
      config.options.forEach((opt, idx) => {
        const option = document.createElement("option");
        option.value = opt;
        option.textContent = opt.charAt(0).toUpperCase() + opt.slice(1);
        if (idx === 0) option.selected = true;
        select.appendChild(option);
      });
      labelSelect.appendChild(select);
      row.appendChild(labelSelect);

      const labelM2 = document.createElement("label");
      const m2Span = document.createElement("span");
      m2Span.className = "font-size-16 neutral-500 font-w-700";
      m2Span.textContent = "m2";
      labelM2.appendChild(m2Span);

      const input = document.createElement("input");
      input.type = "number";
      input.step = "0.1";
      input.name = `m2-room-${handle}-${i}`;
      input.className = "cart-form-input cart-form-m2";
      input.placeholder = "Introduce los m2";
      input.value = "0";
      labelM2.appendChild(input);
      row.appendChild(labelM2);

      const prev = Array.isArray(previousValues) ? previousValues[i] : null;
      if (prev) {
        if (prev.estancia) select.value = prev.estancia;
        if (prev.m2 != null) input.value = prev.m2;
      }

      input.addEventListener("input", refreshSubmitState);
      roomsContainer.appendChild(row);
    }
    refreshSubmitState();
  }

  function readRoomRows() {
    if (!roomsContainer) return [];
    return Array.from(roomsContainer.querySelectorAll(".cart-form-room")).map((row) => ({
      estancia: row.querySelector("select").value,
      m2: row.querySelector('input[type="number"]').value,
    }));
  }

  function refreshSubmitState() {
    if (!submitButton) return;
    const rows = readRoomRows();
    const allFilled = rows.length > 0 && rows.every((r) => parseFloat(r.m2) > 0);
    submitButton.disabled = !allFilled;
  }
  // --- END DYNAMIC ROOM ROWS ------------------------

  function unidadExteriorInputsEvents() {
    unidadExteriorParentInputsPrimeros.forEach((input) => {
      input.addEventListener("click", () => hideDistanciaAzotea(1));
    });
    unidadExteriorParentInputsUltimos.forEach((input) => {
      input.addEventListener("click", () => hideDistanciaBalconPatio(1));
    });
    unidadExteriorParentInputsPrimeros2.forEach((input) => {
      input.addEventListener("click", () => hideDistanciaAzotea(2));
    });
    unidadExteriorParentInputsUltimos2.forEach((input) => {
      input.addEventListener("click", () => hideDistanciaBalconPatio(2));
    });
  }

  function toggleVisibility(parent, childs, isHidden) {
    if (!parent) return;
    parent.style.display = isHidden ? "none" : "block";
    childs.forEach((input) => (input.dataset.isHidden = isHidden.toString()));
  }

  function hideDistanciaAzotea(param) {
    toggleVisibility(distanciaAzoteaParent, distanciaAzoteaChilds, true);
    if (param === 1) {
      toggleVisibility(
        distanciaBalconPatioParent,
        distanciaBalconPatioChilds,
        false
      );
    } else {
      toggleVisibility(
        distanciaBalconPatioParent2,
        distanciaBalconPatioChilds2,
        false
      );
    }
  }

  function hideDistanciaBalconPatio(param) {
    toggleVisibility(distanciaAzoteaParent, distanciaAzoteaChilds, false);
    if (param === 1) {
      toggleVisibility(
        distanciaBalconPatioParent,
        distanciaBalconPatioChilds,
        true
      );
    } else {
      toggleVisibility(
        distanciaBalconPatioParent2,
        distanciaBalconPatioChilds2,
        true
      );
    }
  }

  function formSubmitEvent() {
    if (!form) return;
    form.addEventListener("submit", async function (event) {
      event.preventDefault();

      const rooms = readRoomRows();
      if (rooms.length === 0 || rooms.some((r) => !(parseFloat(r.m2) > 0))) {
        submitButton.disabled = true;
        return;
      }

      const localStorageInitialData = JSON.parse(
        localStorage.getItem(localStorageName)
      );

      let localStorageNewData = { ...localStorageInitialData };

      if (situacionGeograficaInput) {
        localStorageNewData[situacionGeograficaStorageName] = [
          situacionGeograficaInput.options[situacionGeograficaInput.selectedIndex].text,
          situacionGeograficaInput.value,
        ];
      }

      inputsRadio.forEach((inputName) => {
        const input = document.querySelector(
          `input[name="${inputName}"]:checked`
        );
        if (!input) {
          delete localStorageNewData[inputName];
          return;
        }
        const step = input.closest("ff-input-block-submit");
        if (step && step.style.display === "none") {
          delete localStorageNewData[inputName];
          return;
        }
        const label = input.closest("label");
        localStorageNewData[inputName] = [
          label ? label.textContent.trim() : (input.value || ""),
          input.value || 1,
        ];
      });

      localStorageNewData.estancia_metros = [rooms, 1];

      if (isBalconOrPatioSelected()) {
        const distancias = readDistanceRows();
        if (distancias.length) {
          localStorageNewData[distanciaBalconPatioStorageName] = [distancias, 1];
        }
      } else {
        delete localStorageNewData[distanciaBalconPatioStorageName];
      }
      delete localStorageNewData[distanciaBalconPatioStorageName2];

      // Comprobar que inputs tenemos seleccionados en la unidad exterior, para añadir unos u otros al localstorage
      if (someInputChecked(unidadExteriorParentInputsPrimeros)) {
        delete localStorageNewData[distanciaAzoteaStorageName];
      }
      if (someInputChecked(unidadExteriorParentInputsUltimos)) {
        delete localStorageNewData[distanciaBalconPatioStorageName];
      }

      allInputRadioElements.forEach((element) => {
        if (!element.checked || !element.dataset.installation) return;
        const step = element.closest("ff-input-block-submit");
        if (step && step.style.display === "none") return;
        localStorageNewData[installationStorageName] = [element.dataset.installation, 1];
      });

      const { total: potenciaTotal, detalle: potenciaDetalle } = calculatePower(localStorageNewData);
      totalPotenciaRequerida = potenciaTotal;

      localStorageNewData["potencia_total_kw"] = [potenciaTotal, 1];
      localStorageNewData["potencia_por_estancia"] = [potenciaDetalle, 1];

      const configuracion = calculateConfiguracionEstancias(localStorageNewData);
      if (configuracion) {
        localStorageNewData["configuracion_por_estancias"] = [configuracion, 1];
      }

      const match = matchProduct({
        configuracion,
        potenciaDetalle,
        potenciaTotal,
        productsFromShopifyCollection,
      });
      product_id = match.id;

      localStorageNewData["product_id"] = [product_id, 1];
      localStorageNewData["product_handle"] = [match.handle, 1];

      if (match.idSecondary) {
        localStorageNewData["product_id_2"] = [match.idSecondary, 1];
        localStorageNewData["product_handle_2"] = [match.handleSecondary, 1];
      } else {
        delete localStorageNewData["product_id_2"];
        delete localStorageNewData["product_handle_2"];
      }

      localStorage.setItem(
        localStorageName,
        JSON.stringify(localStorageNewData)
      );
      cleanLocalStorageByEstancias();

      cart = await getCart();
      updateCartAttributes(localStorageNewData, cart);
    });
  }


  function acceptOpenModalEvent() {
    if (!acceptButton) return;
    acceptButton.addEventListener("click", async function () {
      initialContent.style.display = "none";
      formContent.style.display = "flex";

      const fieldsData = JSON.parse(localStorage.getItem(localStorageName));
      if (!fieldsData) {
        if (onlyOneRoomElement) onlyOneRoomElement.click();
        renderRoomRows(getSelectedEstanciasCount(), null);
        syncDistanciaBalconPatioStep(null);
        submitButton.disabled = true;
        return;
      }

      if (situacionGeograficaInput && fieldsData[situacionGeograficaStorageName]) {
        situacionGeograficaInput.value =
          fieldsData[situacionGeograficaStorageName][1];
      }

      inputsRadio.forEach((inputName) => {
        if (fieldsData[inputName] === undefined) return;
        const data = fieldsData[inputName][0]
          .replaceAll(" ", "-")
          .replaceAll("´", "")
          .replaceAll("á", "a")
          .replaceAll("é", "e")
          .replaceAll("í", "i")
          .replaceAll("ó", "o")
          .replaceAll("ú", "u")
          .replaceAll("Á", "A")
          .replaceAll("É", "E")
          .replaceAll("Í", "I")
          .replaceAll("Ó", "O")
          .replaceAll("Ú", "U")
          .replaceAll("ñ", "n")
          .replaceAll("Ñ", "N");
        const dataInput = document.getElementById(`${inputName}-${data}`);
        dataInput && (dataInput.checked = true);
      });

      togglePreferenciaUnidadStep(isSecondEstanciasOption());
      if (isLastEstanciasOption()) {
        toggleRoomsStep(false);
        if (roomsContainer) roomsContainer.innerHTML = "";
      } else {
        toggleRoomsStep(true);
        const estanciasData = fieldsData[estanciaMetrosStorageName] && fieldsData[estanciaMetrosStorageName][0];
        const savedCount = Array.isArray(estanciasData) ? estanciasData.length : getSelectedEstanciasCount();
        renderRoomRows(savedCount, estanciasData);
      }
      const savedDistancias = fieldsData[distanciaBalconPatioStorageName] && fieldsData[distanciaBalconPatioStorageName][0];
      syncDistanciaBalconPatioStep(savedDistancias);

      ffInputBlockSubmit.forEach((input) => {
        input.init();
      });
    });
  }

  function setDisplay(el, value) {
    if (el) el.style.display = value;
  }

  function distanceStepIsVisible() {
    return !!(distanciaBalconPatioStep && distanciaBalconPatioStep.style.display !== "none");
  }

  function updateRooms() {
    numberOfRoomsArray.forEach((room) => {
      room.addEventListener("click", function () {
        togglePreferenciaUnidadStep(isSecondEstanciasOption());
        if (isLastEstanciasOption()) {
          toggleRoomsStep(false);
          if (roomsContainer) roomsContainer.innerHTML = "";
          refreshSubmitState();
        } else {
          toggleRoomsStep(true);
          const n = getSelectedEstanciasCount();
          const previous = readRoomRows();
          renderRoomRows(n, previous);
        }
        // Re-render filas de distancia solo si el step ya estaba visible; no
        // tocamos la visibilidad de distancia/azotea/altura aquí (eso lo
        // gestiona el radio unidad_exterior).
        if (distanceStepIsVisible()) renderDistanceRows(readDistanceRows());
      });
    });
  }

  function unidadExteriorDistanciaEvent() {
    const radios = document.querySelectorAll(`input[name="${unidadExteriorStorageName}"]`);
    radios.forEach((radio) => {
      radio.addEventListener("click", () => {
        syncDistanciaBalconPatioStep(readDistanceRows());
      });
    });
  }

  async function updateCartAttributes(finalRecommendation, cart) {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributes: finalRecommendation }),
      });

      await response.json();

      handleCartLogic(cart);
    } catch (error) {
      console.error("Error al actualizar atributos:", error);
    }
  }

  async function handleCartLogic(cart) {
    const goToCheckout = () => window.location.assign('/checkout');
    if (window.StockCheck) {
      window.StockCheck.interceptCheckout(goToCheckout);
    } else {
      goToCheckout();
    }
  }

  function someInputChecked(arr) {
    return arr.some((input) => input.checked);
  }

  function calculatePower(localStorageNewData) {
    // PN = m\u00b2 \u00d7 W/m\u00b2 \u00d7 Fo \u00d7 Fa \u00d7 Fe \u00d7 Fv  \u2192  W, /1000 para kW
    const factorEstancia = {
      habitacion: 1,
      salon: 1.2,
      comedor: 1.2,
      estudio: 1.05,
    };

    const wPorM2 = parseFloat(localStorageNewData[situacionGeograficaStorageName][1]);
    const fo = parseFloat(localStorageNewData[orientacionSolarStorageName][1]);
    const fa = parseFloat(
      (localStorageNewData[anoViviendaStorageName] || [null, 1])[1]
    ) || 1;
    const fv = parseFloat(localStorageNewData[espacioAcondicionarStorageName][1]);

    const detalle = [];
    let total = 0;

    localStorageNewData.estancia_metros[0].forEach((item) => {
      const tipo = item.estancia
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      const fe = factorEstancia[tipo];
      const potencia = (parseFloat(item.m2) * wPorM2 * fo * fa * fe * fv) / 1000;
      total += potencia;
      detalle.push({ estancia: item.estancia, m2: item.m2, fe, potencia_kW: potencia });
    });

    return { total, detalle };
  }

  function calculateConfiguracionEstancias(localStorageNewData) {
    const estancias = localStorageNewData[estanciaMetrosStorageName] && localStorageNewData[estanciaMetrosStorageName][0];
    if (!Array.isArray(estancias) || estancias.length === 0) return null;

    const count = estancias.length;

    if (count === 1) return "Monosplit 1x1";
    if (count === 2) {
      const meters = estancias
        .map((item) => parseFloat(item.m2))
        .filter((n) => !isNaN(n) && n > 0);

      if (meters.length < 2) return "2x Monosplit 1x1";

      // Ratio <= 1.5x se considera tama\u00f1os similares
      const ratio = Math.max(...meters) / Math.min(...meters);
      const similares = ratio <= 1.5;

      if (similares) {
        const prefHandle =
          "prefieres-una-sola-unidad-exterior-para-toda-la-vivienda-o-te-da-igual-tener-una-por-estancia";
        const prefData = localStorageNewData[prefHandle];
        const prefText = (prefData && prefData[0] ? prefData[0] : "")
          .toString()
          .toLowerCase();
        const prefiereUnaPorEstancia =
          prefText.includes("una por") ||
          prefText.includes("por estancia") ||
          prefText.includes("dos soluciones") ||
          prefText.includes("independiente");
        return prefiereUnaPorEstancia ? "2x Monosplit 1x1" : "Multisplit 2x1";
      }
      return "2x Monosplit 1x1";
    }
    if (count === 3) return "Multisplit 3x1";
    return "Multisplit 4x1";
  }

  function findMonosplitForPower(potenciaObjetivo, products) {
    for (const [id, p] of Object.entries(products)) {
      if (
        p.type === "monosplit" &&
        parseInt(p.rooms, 10) === 1 &&
        p.power >= potenciaObjetivo
      ) {
        return { id, handle: p.handle };
      }
    }
    return { id: null, handle: null };
  }

  function matchProduct({
    configuracion,
    potenciaDetalle,
    potenciaTotal,
    productsFromShopifyCollection,
  }) {
    const familia = configuracion && configuracion.toLowerCase().includes("multisplit")
      ? "multisplit"
      : "monosplit";

    // "Nx1" al final indica estancias por unidad (1 para Monosplit y para "2x Monosplit 1x1", N para Multisplit Nx1)
    const lastToken = (configuracion || "").split(" ").pop();
    const estanciasPorUnidad = parseInt(lastToken.split("x")[0], 10) || 1;

    // "2x Monosplit 1x1": dos unidades independientes, una por estancia \u2192 matcheamos dos productos
    const isTwoMonosplit = /^2x\s+monosplit/i.test(configuracion || "");
    if (isTwoMonosplit && Array.isArray(potenciaDetalle) && potenciaDetalle.length >= 2) {
      const m1 = findMonosplitForPower(potenciaDetalle[0].potencia_kW, productsFromShopifyCollection);
      const m2 = findMonosplitForPower(potenciaDetalle[1].potencia_kW, productsFromShopifyCollection);
      return {
        id: m1.id,
        handle: m1.handle,
        idSecondary: m2.id,
        handleSecondary: m2.handle,
        familia: "monosplit",
      };
    }

    // Monosplit: cada unidad cubre 1 estancia \u2192 debe poder con la mayor
    // Multisplit: una unidad cubre todas las estancias \u2192 debe cubrir la suma
    const maxPorEstancia = Array.isArray(potenciaDetalle) && potenciaDetalle.length
      ? Math.max(...potenciaDetalle.map((d) => d.potencia_kW))
      : 0;
    const potenciaObjetivo = familia === "monosplit" ? maxPorEstancia : potenciaTotal;

    for (const [id, p] of Object.entries(productsFromShopifyCollection)) {
      const cumpleType = p.type === familia;
      const cumpleEstancias = parseInt(p.rooms, 10) === estanciasPorUnidad;
      const cumplePotencia = p.power >= potenciaObjetivo;
      if (cumpleType && cumpleEstancias && cumplePotencia) {
        return { id, handle: p.handle, potenciaObjetivo, familia };
      }
    }
    return { id: null, handle: null, potenciaObjetivo, familia };
  }

  function getLocalStorageObject() {
    return JSON.parse(localStorage.getItem(localStorageName));
  }

  function cleanLocalStorageByEstancias() {
    const localStorageName = "decision_tree";
    const data = getLocalStorageObject();

    if (!data || !data.estancias) return;

    const estancias = data.estancias[0];

    if (estancias === "Una") {
      delete data["unidad_exterior_2"];
      delete data["distancia_balcon_patio_2"];
    } else {
      delete data["unidad_exterior"];
      delete data["distancia_balcon_patio"];
    }

    localStorage.setItem(localStorageName, JSON.stringify(data));
  }

  updateRooms();
  unidadExteriorInputsEvents();
  unidadExteriorDistanciaEvent();
  // recommendationButtonEvent();
  acceptOpenModalEvent();
  formSubmitEvent();
});
